<template>
  <div
    v-if="iconSrc"
    class="my-1 mr-2 pull-left asset-icon-container"
    :style="styleIconContainer"
  >
    <img :src="iconSrc" class="asset-icon" :style="styleIcon" />
  </div>
</template>

<script>
import { getCssColorFilter } from "@/common/color.utilities";

export default {
  name: "AssetIcon",
  props: {
    color: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: true,
    },
    iconSize: {
      type: Number,
      default: 25,
    },
    containerSize: {
      type: Number,
      default: 40,
    },
  },
  computed: {
    iconSrc() {
      if (this.icon) {
        return require(`@/assets/images/icons/assetManagement/asset_${this.icon}.png`);
      }
      return null;
    },
    styleIcon() {
      const filter = getCssColorFilter("#ffffff");
      return {
        width: `${this.iconSize}px`,
        height: `${this.iconSize}px`,
        filter: filter,
      };
    },
    styleIconContainer() {
      if (this.color) {
        return {
          backgroundColor: this.color,
          width: `${this.containerSize}px`,
          height: `${this.containerSize}px`,
        };
      }
      return null;
    },
  },
};
</script>

<style scoped>
.asset-icon-container {
  border-radius: 20px;
  border: 1px solid #ffffff;
  position: relative;
}
.asset-icon {
  margin: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
</style>
